import { ColorOptions, FontSizeOptions, IconNewOptions, TextNewProps } from '@jfs/ui-new'

export enum DropdownTypes {
  DEFAULT_WITH_IMAGE = 'Default',
  RADIO_BUTTON = 'RadioButton',
  DEFAULT_WITHOUT_BORDER = 'defaultWithoiutBorder',
  SELECTABLE_HIGHLIGHT = 'selectableHighlight',
  DEFAULT_WITH_BG = 'defaultWithBg',
  DEFAULT_DOWNLOAD_REPORT = 'DownloadReportType',
}

export interface DropDownProps {
  type?: DropdownTypes
  placeHolder: string
  onChange: (value: number[] | string, position?: { left: number; top: number }) => void
  data: any
  fieldName?: string
  setFieldValue?: (field: string, value: string | number) => void
  hide?: boolean
  onButtonPress?: (fileFormatType: string) => void
  buttonLabel?: string
  showBorder?: boolean
  iconType?: IconNewOptions | null
  title?: string
  dropDownContentFontSize?: FontSizeOptions | number
  chevronColor?: ColorOptions
  label?: string
  allValues?: any
  value?: any
  disabled?: boolean
  error?: string
  touched?: boolean
  testID?: string
  textColor?: ColorOptions
  showSearch?: boolean
  marginTop?: number
  maxHeight?: number
  labelStyle?: TextNewProps
}

export interface itemSelected {
  id: number
  value: string
}

export interface DropDownBoxInterface {
  showBorder?: boolean
  isIconAvailable?: boolean
  onLayout?: (value: Object) => void
  toggleDropdown: (val: boolean) => void
  iconType?: IconNewOptions
  defaultLabel: string
  dropdownVisible: boolean
  type: DropdownTypes
  value: string
  clearSelection: () => void
  disabled?: boolean
  chevronColor?: ColorOptions
  testID?: string
  textColor?: ColorOptions
}
